import { attr } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

const isGlobalTemplate = (pointSystem) =>
  pointSystem &&
  (pointSystem.projectId == null || pointSystem.projectId === '') &&
  (pointSystem.boardId == null || pointSystem.boardId === '');

export default class extends BaseModel {
  static modelName = 'PointSystem';

  static fields = {
    id: attr(),
    projectId: attr(),
    boardId: attr(),
    sourcePointSystemId: attr(),
    name: attr(),
    isHidden: attr(),
    isDefault: attr(),
    shiftsPerPlan: attr({
      getDefault: () => 15,
    }),
  };

  static reducer({ type, payload }, PointSystem) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        PointSystem.all().delete();

        if (payload.pointSystems) {
          payload.pointSystems.forEach((pointSystem) => {
            PointSystem.upsert(pointSystem);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.pointSystems) {
          payload.pointSystems.forEach((pointSystem) => {
            PointSystem.upsert(pointSystem);
          });
        }

        break;
      case ActionTypes.POINT_SYSTEM_UPDATE__SUCCESS:
        PointSystem.upsert(payload.pointSystem);

        break;
      case ActionTypes.CONTENT_TYPE_TEMPLATES_FETCH__SUCCESS: {
        // Не удаляем существующие шаблоны перед upsert — иначе redux-orm
        // каскадно стирает ContentType / ContentCardDefault / планы и т.п.,
        // и параллельный fetch этих сущностей может проиграть гонку → «Нет записей».
        const incomingIds = new Set((payload.items || []).map((item) => String(item.id)));
        PointSystem.all()
          .toModelArray()
          .forEach((model) => {
            if (isGlobalTemplate(model.ref) && !incomingIds.has(String(model.id))) {
              model.delete();
            }
          });
        (payload.items || []).forEach((item) => {
          PointSystem.upsert(item);
        });
        (payload.pointSystems || []).forEach((pointSystem) => {
          PointSystem.upsert(pointSystem);
        });
        break;
      }
      case ActionTypes.CONTENT_TYPE_TEMPLATE_CREATE__SUCCESS:
      case ActionTypes.CONTENT_TYPE_TEMPLATE_UPDATE__SUCCESS:
      case ActionTypes.CONTENT_TYPE_TEMPLATE_DELETE__SUCCESS:
        if (payload.item) {
          PointSystem.upsert(payload.item);
        }
        (payload.pointSystems || []).forEach((pointSystem) => {
          PointSystem.upsert(pointSystem);
        });
        break;
      case ActionTypes.CONTENT_TYPE_TEMPLATE_APPLY__SUCCESS:
        if (payload.pointSystem) {
          PointSystem.upsert(payload.pointSystem);
        }

        break;
      default:
    }
  }
}
